import React, { FC, useEffect, useContext } from 'react';
import { Outlet } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { useFetchUser } from '@shared/hooks';

import { authContext } from '@store/index';

import Header from './Header';
import LayoutMenu from './Menu';

const Layout: FC = () => {
  const [userData, fetchUser] = useFetchUser();
  const [authData] = useContext(authContext);

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <>
      <Header gameKey={authData?.gameKey?.key} />
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default Layout;
